export enum FORM {
  CREATE_SPECIAL_DAY = 'CREATE_SPECIAL_DAY',
  UPDATE_SPECIAL_DAY = 'UPDATE_SPECIAL_DAY',
}
